export default {"src":"/_next/static/media/circleDamage_40.1f8b0105.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};